exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Z9lfoi3k32Mmv3egmTjfA{max-height:80%;overflow:auto}._2XvqW8FQyuMG0IEPDexpXJ{display:none}._2G5yebBO7ppcfaiOMZtiOE:focus{outline:none!important}._3OHm0-6edIOLrH1IfNyv5P .ms-Dialog-main{min-height:160px}", ""]);
// Exports
exports.locals = {
	"content": "_3Z9lfoi3k32Mmv3egmTjfA",
	"hideSubmitButton": "_2XvqW8FQyuMG0IEPDexpXJ",
	"button": "_2G5yebBO7ppcfaiOMZtiOE",
	"dialogBox": "_3OHm0-6edIOLrH1IfNyv5P"
};